import {
  useRef,
  useState,
  useContext,
  useCallback,
  createContext
} from "react";

const AgentAssignmentContext = createContext({
  currentAssignment: null,
  registerAgentAssignment: () => () => {},
  releaseCurrentAssignment: async () => {}
});

export const AgentAssignmentProvider = ({ children }) => {
  const assignmentRef = useRef(null);
  const [currentAssignment, setCurrentAssignment] = useState(null);

  const clearAssignment = useCallback((key) => {
    if (!key || assignmentRef.current?.key === key) {
      assignmentRef.current = null;
      setCurrentAssignment(null);
    }
  }, []);

  const registerAgentAssignment = useCallback(
    (assignment) => {
      assignmentRef.current = assignment;
      setCurrentAssignment(assignment);
      return () => clearAssignment(assignment.key);
    },
    [clearAssignment]
  );

  const releaseCurrentAssignment = useCallback(async () => {
    const assignment = assignmentRef.current;
    if (!assignment?.releaseAssignment) return;
    await assignment.releaseAssignment();
    clearAssignment(assignment.key);
  }, [clearAssignment]);

  return (
    <AgentAssignmentContext.Provider
      value={{
        currentAssignment,
        registerAgentAssignment,
        releaseCurrentAssignment
      }}
    >
      {children}
    </AgentAssignmentContext.Provider>
  );
};

export const useAgentAssignment = () => useContext(AgentAssignmentContext);
